import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { Check } from 'lucide-react';
export function Precio() {
  return <Section background="off-white" id="pricing" data-id="element-225">
      <div className="bg-white rounded-3xl shadow-xl border border-stone-200 overflow-hidden max-w-md mx-auto" data-id="element-226">
        <div className="bg-stone-900 p-4 text-center" data-id="element-227">
          <span className="text-amber-400 font-bold tracking-wider text-sm uppercase" data-id="element-228">
            Oferta Limitada
          </span>
        </div>

        <div className="p-8 md:p-10 text-center" data-id="element-229">
          <p className="text-stone-400 text-lg line-through mb-2" data-id="element-230">ARS 14.990</p>
          <div className="flex items-center justify-center gap-1 mb-8" data-id="element-231">
            <span className="text-2xl font-bold text-stone-900 mt-2" data-id="element-232">ARS</span>
            <span className="text-6xl font-extrabold text-stone-900" data-id="element-233">
              9.990
            </span>
          </div>

          <div className="space-y-4 text-left mb-10" data-id="element-234">
            <div className="flex items-start gap-3" data-id="element-235">
              <Check className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-236" />
              <span className="font-bold text-stone-900" data-id="element-237">
                Semana Resuelta (PDF principal)
              </span>
            </div>
            <div className="flex items-start gap-3" data-id="element-238">
              <Check className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-239" />
              <span data-id="element-240">
                Bono 1: Domingo Cerrado{' '}
                <span className="bg-amber-100 text-amber-800 text-xs font-bold px-2 py-0.5 rounded ml-1" data-id="element-241">
                  GRATIS
                </span>
              </span>
            </div>
            <div className="flex items-start gap-3" data-id="element-242">
              <Check className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-243" />
              <span data-id="element-244">
                Bono 2: Swaps Inteligentes{' '}
                <span className="bg-amber-100 text-amber-800 text-xs font-bold px-2 py-0.5 rounded ml-1" data-id="element-245">
                  GRATIS
                </span>
              </span>
            </div>
            <div className="flex items-start gap-3" data-id="element-246">
              <Check className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-247" />
              <span data-id="element-248">
                Bono 3: Salvavidas 10 Min{' '}
                <span className="bg-amber-100 text-amber-800 text-xs font-bold px-2 py-0.5 rounded ml-1" data-id="element-249">
                  GRATIS
                </span>
              </span>
            </div>
          </div>

          <Button fullWidth className="mb-6 text-lg py-6" data-id="element-250">
            Descargar Pack Completo
          </Button>

          <p className="text-xs text-stone-500 leading-relaxed" data-id="element-251">
            Es menos que una compra improvisada que después te deja con culpa. Y
            mucho menos que el costo mental de decidir comida todos los días.
          </p>
        </div>
      </div>
    </Section>;
}